import { uuidv4 } from '@/helpers/uuid'
export const CHANGE_TYPES = {
  addRowAbove: 'newRowAbove',
  deleteRow: 'deletedRow',
}

export default {
  addChange: function({ changeType, locationId, undo, redo }) {
    let location = this.locationIdToLocation({
      locationId,
      index: this.index,
    })

    let locationNames = this.locationPrinter()(location)


    let change = { ...locationNames, changeType, location, undo, redo, id: uuidv4() }
    this.undoHistory.push(change)
  },
  redoLastChange: function() {
    let change = this.redoHistory.shift()
    if (!change || !change.redo) return

    this.undoHistory.push(change)
    change.redo()
  },
  undoLastChange: function() {
    let change = this.undoHistory.pop()
    if (!change || !change.undo) return

    this.redoHistory.unshift(change)
    change.undo()
  },
  // Not used - messes up the history / order of changes
  undoChange: function(change) {
    let index = this.undoHistory.findIndex(c => c.id == change.id)
    this.undoHistory.splice(index, 1)
    this.redoHistory.unshift(change)
    change.undo()
  },
}